export default __webpack_public_path__ + "static/media/slider-bkb.93649bcd.png";